import { css } from '@linaria/core';
export const tableContainer = "odules__Home__cards__MyCompute_styles_ts-tableContainer-t1t24tep";
export const btnStyle = "odules__Home__cards__MyCompute_styles_ts-btnStyle-bq2xjkb";
export const footer = "odules__Home__cards__MyCompute_styles_ts-footer-fjhyja0";

require("./MyCompute.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./MyCompute.styles.ts");